<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="设备">
              <a-input placeholder="请输入设备" v-model="queryParam.devId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="运行状态">
              <a-input placeholder="请输入运行状态" v-model="queryParam.curStatus"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('设备运行情况')" icon="download" type="primary">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="statusSlot" slot-scope="curStatus, item">
          <a-tag color="gray" v-if="item.curStatus==0">停止</a-tag>
          <a-tag color="#52c41a" v-else>运行</a-tag>
        </span>

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="showDetail(record)">详情</a>
        </span>
      </a-table>
    </div>

    <dev-running-info-modal @ok="modalFormOk" ref="modalForm"></dev-running-info-modal>
    <dev-running-detail-modal @ok="modalFormOk" ref="modalDetail"></dev-running-detail-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevRunningInfoModal from './modules/DevRunningInfoModal'
  import DevRunningDetailModal from "./modules/DevRunningDetailModal"

  export default {
    name: 'DevRunningInfoList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevRunningInfoModal,
      DevRunningDetailModal
    },
    data () {
      return {
        description: 'dev_running_info管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '设备',
            align: "center",
            dataIndex: 'devId_dictText'
          },
          {
            title: '运行状态',
            align: "center",
            dataIndex: 'curStatus',
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title: '上次开启时刻',
            align: "center",
            dataIndex: 'lastOpenTime'
          },
          {
            title: '持续运行时长(分)',
            align: "center",
            dataIndex: 'continuousRunningDuration'
          },
          {
            title: '首次开启时刻',
            align: "center",
            dataIndex: 'firstOpenTime'
          },
          {
            title: '历史累计运行时长(分)',
            align: "center",
            dataIndex: 'totalRunningDuration'
          },
          {
            title: '停机次数',
            align: "center",
            dataIndex: 'shutdownCount'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/monitor/devRunning/list",
          exportXlsUrl: "/monitor/devRunning/exportXls",
        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      showDetail (record) {
        this.$refs.modalDetail.show(record.devId)
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'int', value: 'devId', text: '设备', dictCode: '' })
        fieldList.push({ type: 'int', value: 'curStatus', text: '运行状态', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'lastOpenTime', text: '上次开启时刻' })
        fieldList.push({ type: 'int', value: 'continuousRunningDuration', text: '持续运行时长(分)', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'firstOpenTime', text: '首次开启时刻' })
        fieldList.push({ type: 'int', value: 'totalRunningDuration', text: '历史累计运行时长(分)', dictCode: '' })
        fieldList.push({ type: 'int', value: 'shutdownCount', text: '停机次数', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>